import { render, staticRenderFns } from "./StatisticView.vue?vue&type=template&id=45814c49&lang=pug&"
import script from "./StatisticView.vue?vue&type=script&lang=js&"
export * from "./StatisticView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports